package com.schoolconnect.app.feature.calendar

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.draw.clip
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppDialogActionStyle
import com.schoolconnect.app.designsystem.AppConfirmationDialog
import com.schoolconnect.app.designsystem.AppConfirmationDialogTone
import com.schoolconnect.app.designsystem.AppDialogDateField
import com.schoolconnect.app.designsystem.AppDialogDefaultColors
import com.schoolconnect.app.designsystem.AppDialogDivider
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDialogFieldColumn
import com.schoolconnect.app.designsystem.AppDialogFooter
import com.schoolconnect.app.designsystem.AppDialogFooterAction
import com.schoolconnect.app.designsystem.AppDialogHeader
import com.schoolconnect.app.designsystem.AppDialogScaffold
import com.schoolconnect.app.designsystem.AppDialogSelectField
import com.schoolconnect.app.designsystem.AppDialogSize
import com.schoolconnect.app.designsystem.AppDialogTextField
import com.schoolconnect.app.designsystem.AppDialogTimeField
import com.schoolconnect.app.designsystem.AppDialogValidationSummary
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.ApiLoadingOverlay
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppInfoBg
import com.schoolconnect.app.designsystem.AppInfoText
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppOutlinedButton
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppSecondaryBackground
import com.schoolconnect.app.designsystem.AppSurface
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.normalizeAppDateInput
import com.schoolconnect.app.designsystem.list.AdminListFooter
import com.schoolconnect.app.designsystem.list.AdminListActionIcons
import com.schoolconnect.app.designsystem.list.AdminListHeaderColumn
import com.schoolconnect.app.designsystem.list.AdminListPrimaryActionButton
import com.schoolconnect.app.designsystem.list.AdminListSearchField
import com.schoolconnect.app.designsystem.list.AdminListSummaryCard
import com.schoolconnect.app.designsystem.list.AdminListTableBodyText
import com.schoolconnect.app.designsystem.list.AdminListTypography
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.coroutines.yield
import io.github.vinceglb.filekit.compose.rememberFilePickerLauncher
import io.github.vinceglb.filekit.core.PickerType
import com.schoolconnect.app.designsystem.list.AdminListSortColumn
import com.schoolconnect.app.designsystem.list.AdminListSortHeaderRow
import com.schoolconnect.app.designsystem.list.AdminListTableBody
import com.schoolconnect.app.designsystem.list.AdminListTableCard
import com.schoolconnect.app.designsystem.list.AdminListTableShimmer
import com.schoolconnect.app.designsystem.list.AdminListToolbarButton
import com.schoolconnect.app.designsystem.list.AdminRowActionItem
import com.schoolconnect.app.designsystem.list.AdminRowActionMenu
import com.schoolconnect.app.feature.common.ShellPageHeader
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import com.schoolconnect.app.feature.attendance.ParentAttendanceChild
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.clock
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.cloud_upload
import ischoolconnect.sharedui.generated.resources.chevron_down
import ischoolconnect.sharedui.generated.resources.chevron_left
import ischoolconnect.sharedui.generated.resources.chevron_right
import ischoolconnect.sharedui.generated.resources.download
import ischoolconnect.sharedui.generated.resources.excel_file
import ischoolconnect.sharedui.generated.resources.eye
import ischoolconnect.sharedui.generated.resources.info_circle
import ischoolconnect.sharedui.generated.resources.more_vertical
import ischoolconnect.sharedui.generated.resources.pencil
import ischoolconnect.sharedui.generated.resources.plus
import ischoolconnect.sharedui.generated.resources.records_list
import ischoolconnect.sharedui.generated.resources.refresh_cw
import ischoolconnect.sharedui.generated.resources.trash
import org.jetbrains.compose.resources.painterResource

private val CalendarBackground = AppSecondaryBackground
private val CalendarBorder = AppBorder
private val CalendarNavy = AppNavy
private val CalendarMuted = AppMuted
private val CalendarBlueSoft = Color(0xFFEAF1FF)
private val CalendarSelectedBorder = AppPrimary
private val CalendarGreen = AppSuccess
private val CalendarRed = AppDanger

@Composable
fun CalendarScreen(
    state: CalendarUiState,
    onEvent: (CalendarUiEvent) -> Unit,
    onBack: () -> Unit,
    contextLine: String? = null,
    headerActions: @Composable RowScope.() -> Unit = {},
    readOnly: Boolean = false,
    shellRoleCode: String = "",
    onChangeRole: () -> Unit = {},
    onLogout: () -> Unit = {},
    parentChildren: List<ParentAttendanceChild> = emptyList(),
    contentHorizontalPadding: Dp = 18.dp,
    contentVerticalPadding: Dp = 12.dp,
    modifier: Modifier = Modifier
) {
    var rowsMenu by remember { mutableStateOf(false) }
    var profileExpanded by remember { mutableStateOf(false) }
    var showAddEvents by remember { mutableStateOf(false) }
    var showImportCalendar by remember { mutableStateOf(false) }
    val query = state.searchQuery.trim()
    val rows = state.items.filter { row ->
        (query.isBlank() || row.title.contains(query, true) || row.eventType.contains(query, true)) &&
            (state.eventType.isBlank() || row.eventType == state.eventType) &&
            (state.statusFilter.isBlank() || row.status == state.statusFilter)
    }
    val pageCount = ((state.totalCount + 19) / 20).coerceAtLeast(1)
    LaunchedEffect(state.saveGeneration) {
        if (state.saveGeneration > 0) showAddEvents = false
    }

    Box(modifier.fillMaxSize().background(CalendarBackground)) {
        Column(Modifier.fillMaxSize().padding(contentHorizontalPadding, contentVerticalPadding), verticalArrangement = Arrangement.spacedBy(16.dp)) {
            ShellPageHeader(
                title = "Calendar",
                subtitle = if (readOnly) "View school events and activities" else "Manage holidays, academic activities and school events",
                detailText = contextLine,
                titleColor = AppPageHeader,
                subtitleColor = AppPageSubtitle,
                detailColor = CalendarMuted,
                headerActions = {
                    headerActions()
                    if (shellRoleCode.isNotBlank()) {
                        ShellTopRightActions(
                            roleLabel = shellRoleLabel(shellRoleCode),
                            roleSubtitle = shellRoleSubtitle(shellRoleCode),
                            initials = shellAvatarInitials(shellRoleLabel(shellRoleCode)),
                            expanded = profileExpanded,
                            onExpandedChange = { profileExpanded = it },
                            onChangeRole = onChangeRole,
                            onLogout = onLogout
                        )
                    }
                }
            )
            if (!readOnly) CalendarViewToggle(state.listView, onEvent)
            if (!readOnly && state.listView) {
                CalendarFilters(state, onEvent)
                AdminListTableCard(
                    modifier = Modifier.fillMaxWidth().weight(1f), minContentWidth = 980.dp,
                    header = { AdminListSortHeaderRow(listOf(
                        AdminListSortColumn("Date", 1f, state.sortField == CalendarSortField.DATE, state.sortAscending) { onEvent(CalendarUiEvent.SortChanged(CalendarSortField.DATE)) },
                        AdminListSortColumn("From", .9f, state.sortField == CalendarSortField.FROM, state.sortAscending) { onEvent(CalendarUiEvent.SortChanged(CalendarSortField.FROM)) },
                        AdminListSortColumn("To", .9f, state.sortField == CalendarSortField.TO, state.sortAscending) { onEvent(CalendarUiEvent.SortChanged(CalendarSortField.TO)) },
                        AdminListSortColumn("Event / Activity", 1.45f, state.sortField == CalendarSortField.TITLE, state.sortAscending) { onEvent(CalendarUiEvent.SortChanged(CalendarSortField.TITLE)) },
                        AdminListSortColumn("Event Type", 1.25f, state.sortField == CalendarSortField.EVENT_TYPE, state.sortAscending) { onEvent(CalendarUiEvent.SortChanged(CalendarSortField.EVENT_TYPE)) },
                        AdminListSortColumn("Status", .9f, state.sortField == CalendarSortField.STATUS, state.sortAscending) { onEvent(CalendarUiEvent.SortChanged(CalendarSortField.STATUS)) }
                    ), actionsLabel = "Actions", actionsWeight = .95f, horizontalPadding = 20.dp, height = 44.dp) },
                    body = {
                        if (state.isLoading) AdminListTableShimmer(
                            columns = listOf(
                                AdminListHeaderColumn("Date", 1f),
                                AdminListHeaderColumn("From", .9f),
                                AdminListHeaderColumn("To", .9f),
                                AdminListHeaderColumn("Event / Activity", 1.45f),
                                AdminListHeaderColumn("Event Type", 1.25f),
                                AdminListHeaderColumn("Status", .9f),
                                AdminListHeaderColumn("Actions", .95f)
                            ),
                            rowCount = 6,
                            modifier = Modifier.fillMaxSize()
                        )
                        else if (rows.isEmpty()) Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) { Text("No calendar events found", color = CalendarMuted) }
                        else AdminListTableBody(items = rows, key = { it.id }, modifier = Modifier.fillMaxSize()) { row ->
                            CalendarEventRow(row, state.selectedId == row.id, onEvent)
                            if (row.id != rows.last().id) HorizontalDivider(color = CalendarBorder)
                        }
                    },
                    footer = { AdminListFooter(pageText = "Showing ${if (rows.isEmpty()) 0 else state.pageIndex * state.pageSize + 1} to ${state.pageIndex * state.pageSize + rows.size} of ${state.totalCount} events", pageIndex = state.pageIndex, pageCount = pageCount, onPageChanged = { onEvent(CalendarUiEvent.PageChanged(it)) }, pageSize = state.pageSize, rowsPerPageExpanded = rowsMenu, onRowsPerPageToggle = { rowsMenu = !rowsMenu }, onRowsPerPageDismiss = { rowsMenu = false }, onPageSizeChanged = { onEvent(CalendarUiEvent.PageSizeChanged(it)) }, footerColor = CalendarMuted, borderColor = CalendarBorder, surfaceColor = AppSurface, primaryColor = AppPrimary, navyColor = CalendarNavy, mutedColor = CalendarMuted) }
                )
            } else CalendarMonthView(state = state, onEvent = onEvent, readOnly = readOnly, onImport = { showImportCalendar = true })
            if (!readOnly && state.listView) {
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End, verticalAlignment = Alignment.CenterVertically) {
                    AdminListToolbarButton("Import Calendar", painterResource(Res.drawable.download), { onEvent(CalendarUiEvent.ImportReset); showImportCalendar = true }, width = 180.dp, borderColor = CalendarBorder, contentColor = CalendarNavy)
                    Spacer(Modifier.width(14.dp))
                    AdminListPrimaryActionButton("Add Events", painterResource(Res.drawable.plus), { showAddEvents = true }, backgroundColor = AppPrimary)
                }
            }
        }
    }
    if (showAddEvents) CalendarAddEventsDialog(
        isSaving = state.isSaving,
        onDismiss = { if (!state.isSaving) showAddEvents = false },
        onSubmit = { events, publish -> onEvent(CalendarUiEvent.AddEventsSubmitted(events, publish)) }
    )
    LaunchedEffect(state.importCompletionGeneration) {
        if (state.importCompletionGeneration > 0) showImportCalendar = false
    }
    if (showImportCalendar) CalendarImportDialog(state, onEvent, onDismiss = { showImportCalendar = false })
    state.editingEvent?.let { event ->
        CalendarEditEventDialog(
            event = event,
            eventTypes = (CalendarEventTypeOptions + state.items.map { it.eventType }).distinct().filter(String::isNotBlank),
            statuses = (CalendarStatusOptions + state.items.map { it.status.uppercase() }).distinct().filter(String::isNotBlank),
            isSaving = state.isSaving,
            onDismiss = { onEvent(CalendarUiEvent.EditDismissed) },
            onSave = { onEvent(CalendarUiEvent.EditSaved(it)) }
        )
    }
    state.viewingEvent?.let { event ->
        CalendarViewEventDialog(event = event, onDismiss = { onEvent(CalendarUiEvent.ViewDismissed) })
    }
    state.deletingEvent?.let { event ->
        AppConfirmationDialog(
            onDismiss = { onEvent(CalendarUiEvent.DeleteDismissed) },
            title = "Delete Calendar Event",
            subtitle = "Remove this event from the calendar.",
            bodyText = "Are you sure you want to delete \"${event.title}\"? This action cannot be undone.",
            confirmLabel = "Delete",
            onConfirm = { onEvent(CalendarUiEvent.DeleteConfirmed) },
            tone = AppConfirmationDialogTone.Danger
        )
    }
}

private typealias CalendarEventDraft = CalendarEventInputUi

@Composable
private fun CalendarAddEventsDialog(
    isSaving: Boolean,
    onDismiss: () -> Unit,
    onSubmit: (List<CalendarEventInputUi>, Boolean) -> Unit
) {
    val eventTypes = CalendarEventTypeOptions
    var drafts by remember { mutableStateOf(listOf(CalendarEventDraft())) }
    var expandedRow by remember { mutableStateOf(-1) }
    var submitted by remember { mutableStateOf(false) }

    fun updateRow(index: Int, update: (CalendarEventDraft) -> CalendarEventDraft) {
        drafts = drafts.mapIndexed { rowIndex, row -> if (rowIndex == index) update(row) else row }
    }

    val validDrafts = drafts.filter { it.date.isNotBlank() || it.title.isNotBlank() || it.eventType.isNotBlank() }
    val hasErrors = validDrafts.isEmpty() || validDrafts.any { normalizeAppDateInput(it.date) == null || it.title.isBlank() || it.eventType.isBlank() }
    fun submit(publish: Boolean) {
        submitted = true
        if (!hasErrors && !isSaving) onSubmit(validDrafts, publish)
    }

    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Wide,
        dialogWidthOverride = 1120.dp,
        maxDialogHeight = 860.dp,
        colors = AppDialogDefaultColors,
        dismissOnClickOutside = false
    ) {
        AppDialogHeader(
            title = "Add Calendar Events",
            subtitle = "Add holidays, academic activities and school events",
            onClose = onDismiss,
            colors = AppDialogDefaultColors,
            height = 86.dp
        )
        AppDialogDivider()
        Column(
            Modifier
                .fillMaxWidth()
                .weight(1f, fill = false)
                .verticalScroll(rememberScrollState())
                .padding(horizontal = 24.dp, vertical = 18.dp),
            verticalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            CalendarEventDraftHeader()
            if (submitted && hasErrors) {
                AppDialogValidationSummary(
                    errors = listOf("Enter a date, event title and event type for every event row."),
                    modifier = Modifier.fillMaxWidth()
                )
            }
            drafts.forEachIndexed { index, draft ->
                CalendarEventDraftRow(
                    draft = draft,
                    eventTypes = eventTypes,
                    typeExpanded = expandedRow == index,
                    onTypeToggle = { expandedRow = if (expandedRow == index) -1 else index },
                    onTypeDismiss = { expandedRow = -1 },
                    onChange = { updateRow(index, it) },
                    onDelete = { drafts = drafts.filterIndexed { rowIndex, _ -> rowIndex != index } }
                )
            }
            AppOutlinedButton(
                onClick = { drafts = drafts + CalendarEventDraft() },
                modifier = Modifier.height(40.dp),
                contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 14.dp),
                colors = androidx.compose.material3.ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary)
            ) {
                Icon(painterResource(Res.drawable.plus), "Add row", tint = AppPrimary, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(7.dp))
                Text("Add row", color = AppPrimary, fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
            }
        }
        AppDialogDivider()
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction("Cancel", onDismiss, AppDialogActionStyle.Secondary, width = 104.dp, enabled = !isSaving),
                AppDialogFooterAction(if (isSaving) "Saving..." else "Save as Draft", { submit(false) }, AppDialogActionStyle.Secondary, width = 170.dp, enabled = !isSaving),
                AppDialogFooterAction(if (isSaving) "Saving..." else "Publish", { submit(true) }, AppDialogActionStyle.Primary, width = 104.dp, enabled = !isSaving)
            ),
            colors = AppDialogDefaultColors,
            footerHeight = 78.dp,
            contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 24.dp)
        )
    }
}

@Composable
private fun CalendarEventDraftHeader() {
    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
        CalendarDraftLabel("Date", Modifier.weight(1.0f))
        CalendarDraftLabel("All Day", Modifier.weight(.45f))
        CalendarDraftLabel("From", Modifier.weight(.8f))
        CalendarDraftLabel("To", Modifier.weight(.8f))
        CalendarDraftLabel("Event / Activity", Modifier.weight(1.45f))
        CalendarDraftLabel("Event Type", Modifier.weight(.95f))
        CalendarDraftLabel("Actions", Modifier.width(54.dp))
    }
}

@Composable
private fun CalendarDraftLabel(text: String, modifier: Modifier = Modifier) {
    Text(text, modifier = modifier, color = CalendarNavy, fontSize = 12.sp, fontWeight = FontWeight.Bold, maxLines = 1)
}

@Composable
private fun CalendarEventDraftRow(
    draft: CalendarEventDraft,
    eventTypes: List<String>,
    typeExpanded: Boolean,
    onTypeToggle: () -> Unit,
    onTypeDismiss: () -> Unit,
    onChange: ((CalendarEventDraft) -> CalendarEventDraft) -> Unit,
    onDelete: () -> Unit
) {
    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
        AppDialogDateField(draft.date, { value -> onChange { it.copy(date = value) } }, Modifier.weight(1.0f), colors = AppDialogDefaultColors, fieldHeight = 40.dp, fontSize = 13.sp, leadingIconStartPadding = 8.dp)
        Box(Modifier.weight(.45f).height(40.dp), contentAlignment = Alignment.Center) {
            Checkbox(
                checked = draft.allDay,
                onCheckedChange = { checked -> onChange { it.copy(allDay = checked) } },
                colors = CheckboxDefaults.colors(checkedColor = AppPrimary, uncheckedColor = CalendarBorder)
            )
        }
        CalendarDraftTimeField(draft.from, draft.allDay, Modifier.weight(.8f)) { value -> onChange { it.copy(from = value) } }
        CalendarDraftTimeField(draft.to, draft.allDay, Modifier.weight(.8f)) { value -> onChange { it.copy(to = value) } }
        AppDialogTextField(draft.title, { value -> onChange { it.copy(title = value) } }, "Event title", Modifier.weight(1.45f), colors = AppDialogDefaultColors, fieldHeight = 40.dp, fontSize = 13.sp)
        Box(Modifier.weight(.95f)) {
            AppDialogSelectField(
                value = draft.eventType,
                placeholder = "Select event type",
                expanded = typeExpanded,
                options = eventTypes,
                onToggleExpanded = onTypeToggle,
                onDismissExpanded = onTypeDismiss,
                onSelected = { value -> onChange { it.copy(eventType = value) }; onTypeDismiss() },
                colors = AppDialogDefaultColors,
                fieldHeight = 40.dp,
                fontSize = 13.sp
            )
        }
        Row(Modifier.width(54.dp), horizontalArrangement = Arrangement.Center, verticalAlignment = Alignment.CenterVertically) {
            Icon(painterResource(Res.drawable.trash), "Delete event", tint = CalendarRed, modifier = Modifier.size(20.dp).clickable(onClick = onDelete))
        }
    }
}

@Composable
private fun CalendarDraftTimeField(value: String, allDay: Boolean, modifier: Modifier, fieldHeight: Dp = 40.dp, onChange: (String) -> Unit) {
    if (allDay) {
        AppDialogTextField(
            value = "",
            onValueChange = {},
            placeholder = "--:--",
            modifier = modifier,
            colors = AppDialogDefaultColors,
            fieldHeight = fieldHeight,
            fontSize = 13.sp,
            readOnly = true,
            trailingIcon = {
                Icon(
                    painter = painterResource(Res.drawable.clock),
                    contentDescription = "Time picker unavailable for all-day event",
                    tint = AppMuted,
                    modifier = Modifier.size(18.dp)
                )
            }
        )
    } else {
        AppDialogTimeField(
            value = value,
            onValueChange = onChange,
            modifier = modifier,
            placeholder = "--:--",
            colors = AppDialogDefaultColors,
            fieldHeight = fieldHeight,
            leadingIconStartPadding = 8.dp
        )
    }
}

@Composable private fun CalendarViewToggle(listView: Boolean, onEvent: (CalendarUiEvent) -> Unit) {
    Row(Modifier.height(42.dp).border(1.dp, CalendarBorder, MaterialTheme.shapes.small).padding(1.dp)) {
        CalendarToggle("List View", painterResource(Res.drawable.records_list), listView) { onEvent(CalendarUiEvent.ListViewSelected) }
        CalendarToggle("Calendar View", painterResource(Res.drawable.calendar), !listView) { onEvent(CalendarUiEvent.CalendarViewSelected) }
    }
}

@Composable private fun CalendarToggle(label: String, icon: Painter, selected: Boolean, onClick: () -> Unit) {
    Row(
        Modifier
            .fillMaxHeight()
            .clip(MaterialTheme.shapes.small)
            .background(if (selected) CalendarBlueSoft else Color.Transparent)
            .border(1.dp, if (selected) CalendarSelectedBorder else Color.Transparent, MaterialTheme.shapes.small)
            .clickable(onClick = onClick)
            .padding(horizontal = 16.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        Icon(icon, label, tint = if (selected) AppPrimary else CalendarNavy, modifier = Modifier.size(18.dp))
        Text(label, color = if (selected) AppPrimary else CalendarNavy, fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Medium, fontSize = 14.sp)
    }
}

@Composable private fun CalendarFilters(state: CalendarUiState, onEvent: (CalendarUiEvent) -> Unit) {
    val selectedYear = state.month.substringAfterLast(' ', "2026").toIntOrNull() ?: 2026
    val monthOptions = (1..12).map { monthNumber ->
        "${listOf("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December")[monthNumber - 1]} $selectedYear"
    }
    val eventTypeOptions = (CalendarEventTypeOptions + state.items.map { it.eventType }).distinct().filter(String::isNotBlank)
    val statusOptions = (CalendarStatusOptions + state.items.map { it.status.uppercase() }).distinct().filter(String::isNotBlank)
    Row(
        Modifier.fillMaxWidth().border(1.dp, CalendarBorder, MaterialTheme.shapes.small).padding(18.dp),
        horizontalArrangement = Arrangement.spacedBy(14.dp),
        verticalAlignment = Alignment.Bottom
    ) {
        CalendarSearchField(state.searchQuery, onEvent, Modifier.weight(1f))
        CalendarDropdown("Month", state.listMonthFilter.ifBlank { "All" }, monthOptions, Modifier.weight(1f), onSelected = { onEvent(CalendarUiEvent.ListMonthChanged(it)) })
        CalendarDropdown("Event Type", state.eventType.ifBlank { "All" }, eventTypeOptions, Modifier.weight(1f), onSelected = { onEvent(CalendarUiEvent.EventTypeChanged(it)) })
        CalendarDropdown("Status", state.statusFilter.ifBlank { "All" }, statusOptions, Modifier.weight(1f), onSelected = { onEvent(CalendarUiEvent.StatusChanged(it)) })
        CalendarClearButton(onEvent)
    }
}

@Composable private fun CalendarSearchField(query: String, onEvent: (CalendarUiEvent) -> Unit, modifier: Modifier) {
    BoxWithConstraints(modifier) {
        val availableWidth = maxWidth
        Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(7.dp)) {
            Spacer(Modifier.height(18.dp))
            AdminListSearchField(query, { onEvent(CalendarUiEvent.SearchChanged(it)) }, "Search events", width = availableWidth, surfaceColor = Color.White, borderColor = CalendarBorder, iconTint = CalendarMuted, textColor = CalendarNavy)
        }
    }
}

@Composable private fun CalendarClearButton(onEvent: (CalendarUiEvent) -> Unit) {
    Box(Modifier.width(84.dp).height(44.dp).background(AppSurface, MaterialTheme.shapes.small).border(1.dp, CalendarBorder, MaterialTheme.shapes.small).clickable { onEvent(CalendarUiEvent.FiltersCleared) }, contentAlignment = Alignment.Center) {
        Text("Clear", color = AppPrimary, fontWeight = FontWeight.SemiBold, fontSize = 14.sp)
    }
}

@Composable private fun CalendarDropdown(label: String, value: String, options: List<String>, modifier: Modifier, onSelected: (String) -> Unit, includeAll: Boolean = true) {
    var expanded by remember { mutableStateOf(false) }
    val selectionScope = rememberCoroutineScope()
    fun select(option: String) {
        // Keep the menu item attached until Compose JS finishes its click sound
        // interaction. Updating the filter first removes the popup node while
        // the pointer handler is still reading its CompositionLocal.
        selectionScope.launch {
            yield()
            delay(100)
            expanded = false
            onSelected(option)
        }
    }
    Column(modifier, verticalArrangement = Arrangement.spacedBy(7.dp)) {
        Text(label, color = CalendarNavy, style = MaterialTheme.typography.labelMedium)
        Box(
            Modifier
                .fillMaxWidth()
                .height(44.dp)
                .background(AppSurface, MaterialTheme.shapes.small)
                .border(1.dp, CalendarBorder, MaterialTheme.shapes.small)
                .clickable { expanded = true }
                .padding(horizontal = 14.dp),
            contentAlignment = Alignment.CenterStart
        ) {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceBetween, verticalAlignment = Alignment.CenterVertically) {
                Text(value.ifBlank { currentCalendarMonthLabel() }, color = CalendarNavy, fontSize = AdminListTypography.Control, fontWeight = AdminListTypography.ControlWeight, maxLines = 1)
                Icon(painterResource(Res.drawable.chevron_down), label, tint = CalendarNavy, modifier = Modifier.size(18.dp))
            }
            AppDropdownMenu(expanded, { expanded = false }, containerColor = Color.White, border = BorderStroke(1.dp, CalendarBorder)) {
                if (includeAll) DropdownMenuItem(text = { Text("All", color = CalendarNavy, fontSize = AdminListTypography.Control) }, onClick = { select("") })
                options.forEach { option -> DropdownMenuItem(text = { Text(option, color = CalendarNavy) }, onClick = { select(option) }) }
            }
        }
    }
}

@Composable private fun CalendarEventRow(row: CalendarRowUi, expanded: Boolean, onEvent: (CalendarUiEvent) -> Unit) {
    Row(Modifier.fillMaxWidth().heightIn(min = 52.dp).padding(horizontal = 16.dp, vertical = 4.dp), verticalAlignment = Alignment.CenterVertically) {
        CalendarCell(row.date, 1f); CalendarCell(row.from, .9f); CalendarCell(row.to, .9f); CalendarCell(row.title, 1.45f); CalendarCell(row.eventType, 1.25f)
        Box(Modifier.weight(.9f)) {
            AdminListTableBodyText(
                text = row.status,
                color = if (row.status.equals("Published", true)) CalendarGreen else CalendarRed,
                fontWeight = AdminListTypography.TableBodyWeightStrong
            )
        }
        Box(Modifier.weight(.95f), contentAlignment = Alignment.CenterEnd) {
            AdminListActionIcons(
                onView = { onEvent(CalendarUiEvent.ViewRequested(row.id)) },
                onEdit = { onEvent(CalendarUiEvent.EditRequested(row.id)) }
            ) {
                IconButton(onClick = { onEvent(CalendarUiEvent.RowActionsToggled(row.id)) }, modifier = Modifier.size(32.dp)) {
                    Icon(painterResource(Res.drawable.more_vertical), "More actions", tint = CalendarNavy, modifier = Modifier.size(16.dp))
                }
                val actions = mutableListOf(
                    listOf(AdminRowActionItem("Delete", { onEvent(CalendarUiEvent.DeleteRequested(row.id)) }, painterResource(Res.drawable.trash), CalendarRed, CalendarRed))
                )
            if (!row.status.equals("PUBLISHED", ignoreCase = true)) {
                actions.add(listOf(AdminRowActionItem("Publish", { onEvent(CalendarUiEvent.PublishRequested(row.id)) }, painterResource(Res.drawable.plus))))
            }
                AdminRowActionMenu(actions, { onEvent(CalendarUiEvent.RowActionsDismissed) }, expanded = expanded, width = 150.dp)
            }
        }
    }
}

private data class CalendarEditDraft(
    val date: String,
    val allDay: Boolean,
    val from: String,
    val to: String,
    val title: String,
    val eventType: String,
    val status: String
)

@Composable
private fun CalendarEditEventDialog(
    event: CalendarRowUi,
    eventTypes: List<String>,
    statuses: List<String>,
    isSaving: Boolean,
    onDismiss: () -> Unit,
    onSave: (CalendarRowUi) -> Unit
) {
    var draft by remember(event.id) {
        mutableStateOf(
            CalendarEditDraft(
                date = calendarDateForDialog(event.date),
                allDay = event.isAllDay,
                from = if (event.isAllDay) "" else event.from,
                to = if (event.isAllDay) "" else event.to,
                title = event.title,
                eventType = event.eventType,
                status = event.status
            )
        )
    }
    var submitted by remember(event.id) { mutableStateOf(false) }
    var eventTypeExpanded by remember { mutableStateOf(false) }
    var statusExpanded by remember { mutableStateOf(false) }

    val dateError = if (submitted && normalizeAppDateInput(draft.date) == null) "Enter a valid date." else ""
    val titleError = if (submitted && draft.title.isBlank()) "Event / Activity is required." else ""
    val typeError = if (submitted && draft.eventType.isBlank()) "Event type is required." else ""
    val statusError = if (submitted && draft.status.isBlank()) "Status is required." else ""
    val hasErrors = dateError.isNotBlank() || titleError.isNotBlank() || typeError.isNotBlank() || statusError.isNotBlank()

    fun save() {
        submitted = true
        if (hasErrors) return
        onSave(event.copy(
            date = calendarDateForDialog(draft.date),
            from = if (draft.allDay) "All Day" else draft.from,
            to = if (draft.allDay) "—" else draft.to,
            title = draft.title.trim(),
            eventType = draft.eventType,
            status = draft.status,
            isAllDay = draft.allDay
        ))
    }

    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Standard,
        dialogWidthOverride = 720.dp,
        maxDialogHeight = 680.dp,
        colors = AppDialogDefaultColors,
        dismissOnClickOutside = false
    ) {
        AppDialogHeader(
            title = "Edit Calendar Event",
            subtitle = "Update calendar event details",
            onClose = onDismiss,
            colors = AppDialogDefaultColors,
            height = 86.dp
        )
        AppDialogValidationSummary(
            errors = listOf(dateError, titleError, typeError, statusError),
            modifier = Modifier.padding(horizontal = 28.dp, vertical = 4.dp)
        )
        BoxWithConstraints(Modifier.fillMaxWidth().padding(horizontal = 28.dp, vertical = 20.dp)) {
            val compact = maxWidth < 620.dp
            if (compact) {
                Column(verticalArrangement = Arrangement.spacedBy(18.dp)) {
                AppDialogFieldColumn("Date", required = true, error = dateError, colors = AppDialogDefaultColors) {
                    AppDialogDateField(draft.date, { draft = draft.copy(date = it) }, error = dateError, colors = AppDialogDefaultColors, leadingIconStartPadding = 8.dp)
                }
                AppDialogFieldColumn("All Day", colors = AppDialogDefaultColors) {
                    Row(Modifier.height(48.dp), verticalAlignment = Alignment.CenterVertically) {
                        Checkbox(
                            checked = draft.allDay,
                            onCheckedChange = { checked -> draft = draft.copy(allDay = checked, from = if (checked) "" else draft.from, to = if (checked) "" else draft.to) },
                            colors = CheckboxDefaults.colors(checkedColor = AppPrimary, uncheckedColor = CalendarBorder)
                        )
                        Text("This is an all-day event", color = CalendarMuted, fontSize = 13.sp)
                    }
                }
                AppDialogFieldColumn("From", colors = AppDialogDefaultColors) {
                    CalendarDraftTimeField(draft.from, draft.allDay, Modifier.fillMaxWidth(), onChange = { draft = draft.copy(from = it) }, fieldHeight = 54.dp)
                }
                AppDialogFieldColumn("To", colors = AppDialogDefaultColors) {
                    CalendarDraftTimeField(draft.to, draft.allDay, Modifier.fillMaxWidth(), onChange = { draft = draft.copy(to = it) }, fieldHeight = 54.dp)
                }
                AppDialogFieldColumn("Event / Activity", required = true, error = titleError, colors = AppDialogDefaultColors) {
                    AppDialogTextField(draft.title, { draft = draft.copy(title = it) }, "Enter event or activity", error = titleError, colors = AppDialogDefaultColors)
                }
                AppDialogFieldColumn("Event Type", required = true, error = typeError, colors = AppDialogDefaultColors) {
                    AppDialogSelectField(draft.eventType, "Select event type", eventTypeExpanded, eventTypes, { eventTypeExpanded = !eventTypeExpanded }, { eventTypeExpanded = false }, { draft = draft.copy(eventType = it); eventTypeExpanded = false }, error = typeError, colors = AppDialogDefaultColors)
                }
                AppDialogFieldColumn("Status", required = true, error = statusError, colors = AppDialogDefaultColors) {
                    AppDialogSelectField(draft.status, "Select status", statusExpanded, statuses, { statusExpanded = !statusExpanded }, { statusExpanded = false }, { draft = draft.copy(status = it); statusExpanded = false }, error = statusError, colors = AppDialogDefaultColors)
                }
                }
            } else {
                Column(verticalArrangement = Arrangement.spacedBy(22.dp)) {
                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(22.dp), verticalAlignment = Alignment.Bottom) {
                        AppDialogFieldColumn("Date", modifier = Modifier.weight(1f), required = true, error = dateError, colors = AppDialogDefaultColors) {
                            AppDialogDateField(draft.date, { draft = draft.copy(date = it) }, error = dateError, colors = AppDialogDefaultColors, leadingIconStartPadding = 8.dp)
                        }
                        AppDialogFieldColumn("All Day", modifier = Modifier.weight(1f), colors = AppDialogDefaultColors) {
                            Row(Modifier.height(48.dp), verticalAlignment = Alignment.CenterVertically) {
                                Checkbox(
                                    checked = draft.allDay,
                                    onCheckedChange = { checked -> draft = draft.copy(allDay = checked, from = if (checked) "" else draft.from, to = if (checked) "" else draft.to) },
                                    colors = CheckboxDefaults.colors(checkedColor = AppPrimary, uncheckedColor = CalendarBorder)
                                )
                                Text("This is an all-day event", color = CalendarMuted, fontSize = 13.sp)
                            }
                        }
                    }
                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(22.dp)) {
                        AppDialogFieldColumn("From", modifier = Modifier.weight(1f), colors = AppDialogDefaultColors) {
                            CalendarDraftTimeField(draft.from, draft.allDay, Modifier.fillMaxWidth(), onChange = { draft = draft.copy(from = it) }, fieldHeight = 54.dp)
                        }
                        AppDialogFieldColumn("To", modifier = Modifier.weight(1f), colors = AppDialogDefaultColors) {
                            CalendarDraftTimeField(draft.to, draft.allDay, Modifier.fillMaxWidth(), onChange = { draft = draft.copy(to = it) }, fieldHeight = 54.dp)
                        }
                    }
                    AppDialogFieldColumn("Event / Activity", required = true, error = titleError, colors = AppDialogDefaultColors) {
                        AppDialogTextField(draft.title, { draft = draft.copy(title = it) }, "Enter event or activity", error = titleError, colors = AppDialogDefaultColors)
                    }
                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(22.dp)) {
                        AppDialogFieldColumn("Event Type", modifier = Modifier.weight(1f), required = true, error = typeError, colors = AppDialogDefaultColors) {
                            AppDialogSelectField(draft.eventType, "Select event type", eventTypeExpanded, eventTypes, { eventTypeExpanded = !eventTypeExpanded }, { eventTypeExpanded = false }, { draft = draft.copy(eventType = it); eventTypeExpanded = false }, error = typeError, colors = AppDialogDefaultColors)
                        }
                        AppDialogFieldColumn("Status", modifier = Modifier.weight(1f), required = true, error = statusError, colors = AppDialogDefaultColors) {
                            AppDialogSelectField(draft.status, "Select status", statusExpanded, statuses, { statusExpanded = !statusExpanded }, { statusExpanded = false }, { draft = draft.copy(status = it); statusExpanded = false }, error = statusError, colors = AppDialogDefaultColors)
                        }
                    }
                }
            }
        }
        AppDialogDivider()
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction("Cancel", onDismiss, AppDialogActionStyle.Secondary, width = 120.dp, enabled = !isSaving),
                AppDialogFooterAction(if (isSaving) "Saving..." else "Save", ::save, AppDialogActionStyle.Primary, width = 120.dp, enabled = !isSaving)
            ),
            colors = AppDialogDefaultColors,
            footerHeight = 78.dp,
            contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 28.dp)
        )
    }
}

@Composable
private fun CalendarViewEventDialog(event: CalendarRowUi, onDismiss: () -> Unit) {
    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Standard,
        dialogWidthOverride = 700.dp,
        maxDialogHeight = 760.dp,
        colors = AppDialogDefaultColors,
        dismissOnClickOutside = false
    ) {
        AppDialogHeader(
            title = "View Calendar Event",
            subtitle = "View calendar event details",
            onClose = onDismiss,
            colors = AppDialogDefaultColors,
            height = 86.dp
        )
        AppDialogDivider()
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f, fill = false)
                .verticalScroll(rememberScrollState())
                .padding(horizontal = 28.dp, vertical = 22.dp),
            verticalArrangement = Arrangement.spacedBy(18.dp)
        ) {
            CalendarViewDetailRow("Date", calendarDateForDialog(event.date))
            CalendarViewDetailRow("All Day", if (event.isAllDay) "Yes" else "No")
            CalendarViewDetailRow("From", if (event.isAllDay) "All Day" else event.from.ifBlank { "—" })
            CalendarViewDetailRow("To", event.to.ifBlank { "—" })
            CalendarViewDetailRow("Event / Activity", event.title)
            CalendarViewDetailRow("Event Type", event.eventType)
            CalendarViewDetailRow(
                label = "Status",
                value = event.status,
                valueColor = if (event.status.equals("Published", true)) CalendarGreen else CalendarRed
            )
            AppDialogDivider()
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(24.dp)) {
                CalendarViewAuditItem("Created On", calendarAuditDate(event.createdOn), Modifier.weight(1f))
                CalendarViewAuditItem("Created By", calendarAuditId(event.createdBy), Modifier.weight(1f))
            }
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(24.dp)) {
                CalendarViewAuditItem("Last Updated On", calendarAuditDate(event.lastUpdatedOn), Modifier.weight(1f))
                CalendarViewAuditItem("Last Updated By", calendarAuditId(event.lastUpdatedBy), Modifier.weight(1f))
            }
        }
        AppDialogDivider()
        AppDialogFooter(
            actions = listOf(
                AppDialogFooterAction("Close", onDismiss, AppDialogActionStyle.Primary, width = 104.dp)
            ),
            colors = AppDialogDefaultColors,
            footerHeight = 78.dp,
            contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 28.dp)
        )
    }
}

private fun calendarDateForDialog(value: String): String {
    normalizeAppDateInput(value)?.let { return it }
    val match = Regex("""^([A-Za-z]+)\s+(\d{1,2}),?\s+(\d{4})$""").matchEntire(value.trim()) ?: return value
    val month = when (match.groupValues[1].lowercase()) {
        "jan", "january" -> "Jan"
        "feb", "february" -> "Feb"
        "mar", "march" -> "Mar"
        "apr", "april" -> "Apr"
        "may" -> "May"
        "jun", "june" -> "Jun"
        "jul", "july" -> "Jul"
        "aug", "august" -> "Aug"
        "sep", "sept", "september" -> "Sep"
        "oct", "october" -> "Oct"
        "nov", "november" -> "Nov"
        "dec", "december" -> "Dec"
        else -> return value
    }
    return "${match.groupValues[2].padStart(2, '0')} $month ${match.groupValues[3]}"
}

@Composable
private fun CalendarViewDetailRow(label: String, value: String, valueColor: Color = CalendarNavy) {
    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(24.dp)) {
        Text(label, modifier = Modifier.weight(1f), color = CalendarNavy, fontSize = 14.sp, fontWeight = FontWeight.SemiBold)
        Text(value.ifBlank { "—" }, modifier = Modifier.weight(1.7f), color = valueColor, fontSize = 14.sp, fontWeight = FontWeight.Medium)
    }
}

@Composable
private fun CalendarViewAuditItem(label: String, value: String, modifier: Modifier = Modifier) {
    Row(modifier, horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
        Text(label, modifier = Modifier.width(112.dp), color = CalendarNavy, fontSize = 12.sp, fontWeight = FontWeight.SemiBold, maxLines = 1)
        Text(value, modifier = Modifier.weight(1f), color = CalendarMuted, fontSize = 12.sp, fontWeight = FontWeight.Medium, maxLines = 1, overflow = TextOverflow.Ellipsis)
    }
}

private fun calendarAuditDate(value: String): String {
    val match = Regex("""^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}).*$""").matchEntire(value.trim()) ?: return value.ifBlank { "—" }
    val monthIndex = match.groupValues[2].toIntOrNull()?.minus(1) ?: return value
    val month = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec").getOrNull(monthIndex) ?: return value
    return "${match.groupValues[3]} $month ${match.groupValues[1]}, ${match.groupValues[4]}:${match.groupValues[5]}"
}

private fun calendarAuditId(value: String): String {
    val normalized = value.trim()
    if (normalized.isBlank()) return "—"
    val isUuid = Regex("""^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$""").matches(normalized)
    return if (isUuid) "${normalized.take(8)}…${normalized.takeLast(4)}" else normalized
}

private data class CalendarImportPreviewRow(
    val date: String,
    val from: String,
    val to: String,
    val title: String,
    val type: String
)

@Composable
private fun CalendarImportDialog(
    state: CalendarUiState,
    onEvent: (CalendarUiEvent) -> Unit,
    onDismiss: () -> Unit
) {
    var reviewStep by remember { mutableStateOf(false) }
    val pickerScope = rememberCoroutineScope()
    val picker = rememberFilePickerLauncher(type = PickerType.File(listOf("xlsx")), title = "Select Calendar Workbook") { file ->
        if (file != null) pickerScope.launch {
            runCatching { file.readBytes() }.onSuccess { bytes -> onEvent(CalendarUiEvent.ImportFileSelected(file.name, bytes)) }
                .onFailure { error ->
                    onEvent(CalendarUiEvent.ImportFileReadFailed(error.message.orEmpty().ifBlank { "Unable to read the selected workbook." }))
                }
        }
    }
    val validation = state.importValidation
    val previewRows = validation?.validPayloadPreview.orEmpty().map { CalendarImportPreviewRow(it.date, it.from, it.to, it.title, it.type) }

    AppDialogScaffold(
        onDismiss = onDismiss,
        size = AppDialogSize.Wide,
        dialogWidthOverride = 1060.dp,
        maxDialogHeight = 860.dp,
        colors = AppDialogDefaultColors,
        dismissOnClickOutside = false,
        isLoading = state.importIsLoading,
        loadingTitle = "Updating data"
    ) {
        AppDialogHeader(
            title = "Import Calendar",
            subtitle = if (reviewStep) "Review validated events before importing" else "Upload and validate calendar events before importing",
            onClose = onDismiss,
            colors = AppDialogDefaultColors,
            height = 86.dp
        )
        Column(
            Modifier
                .fillMaxWidth()
                .heightIn(max = 520.dp)
                .verticalScroll(rememberScrollState())
                .padding(horizontal = 28.dp, vertical = 18.dp),
            verticalArrangement = Arrangement.spacedBy(18.dp)
        ) {
            CalendarImportStepper(reviewStep)
            if (reviewStep && validation != null) {
                CalendarImportSummary(total = validation.totalRows, valid = validation.validRows, invalid = validation.invalidRows)
                CalendarImportInfo("Only ${validation.validRows} valid rows will be imported. Invalid rows will be excluded.")
                CalendarImportPreviewTable(previewRows)
            } else {
                CalendarImportUploadCard(state, picker::launch, onEvent)
                Text("Validation Summary", color = CalendarNavy, fontSize = 16.sp, fontWeight = FontWeight.ExtraBold)
                CalendarImportSummary(total = validation?.totalRows ?: 0, valid = validation?.validRows ?: 0, invalid = validation?.invalidRows ?: 0)
                if (validation != null) CalendarImportInfo("${validation.invalidRows} invalid rows will be excluded. Only ${validation.validRows} valid rows will continue to Review & Import.")
                Text("Validation Results (Invalid Rows Only)", color = CalendarNavy, fontSize = 15.sp, fontWeight = FontWeight.ExtraBold)
                CalendarImportInvalidTable(validation?.errors.orEmpty())
            }
        }
        AppDialogDivider()
        if (reviewStep) {
            AppDialogFooter(
                actions = listOf(
                    AppDialogFooterAction("Back", { reviewStep = false }, AppDialogActionStyle.Secondary, width = 104.dp),
                    AppDialogFooterAction("Cancel", onDismiss, AppDialogActionStyle.Secondary, width = 120.dp),
                    AppDialogFooterAction("Import as Draft", { onEvent(CalendarUiEvent.ImportCommitRequested(false)) }, AppDialogActionStyle.Secondary, width = 160.dp),
                    AppDialogFooterAction("Import & Publish", { onEvent(CalendarUiEvent.ImportCommitRequested(true)) }, AppDialogActionStyle.Primary, width = 170.dp)
                ),
                colors = AppDialogDefaultColors,
                footerHeight = 78.dp,
                contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 28.dp)
            )
        } else {
            AppDialogFooter(
                actions = listOf(
                    AppDialogFooterAction("Cancel", onDismiss, AppDialogActionStyle.Secondary, width = 120.dp),
                    AppDialogFooterAction("Continue to Review", { if (validation != null && validation.validRows > 0) reviewStep = true }, AppDialogActionStyle.Primary, width = 190.dp)
                ),
                colors = AppDialogDefaultColors,
                footerHeight = 78.dp,
                contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 28.dp)
            )
        }
    }
}

@Composable
private fun CalendarImportStepper(reviewStep: Boolean) {
    Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
        CalendarImportStep("1", "Upload & Validate", !reviewStep, completed = reviewStep)
        Box(Modifier.weight(1f).padding(horizontal = 14.dp).height(2.dp).background(if (reviewStep) AppPrimary else CalendarBorder))
        CalendarImportStep("2", "Review & Import", reviewStep, completed = false)
    }
}

@Composable
private fun CalendarImportStep(number: String, label: String, active: Boolean, completed: Boolean) {
    Row(horizontalArrangement = Arrangement.spacedBy(10.dp), verticalAlignment = Alignment.CenterVertically) {
        Box(
            Modifier
                .size(36.dp)
                .background(if (active || completed) AppPrimary else Color.Transparent, androidx.compose.foundation.shape.CircleShape)
                .border(1.dp, if (active || completed) AppPrimary else CalendarBorder, androidx.compose.foundation.shape.CircleShape),
            contentAlignment = Alignment.Center
        ) {
            Text(if (completed) "✓" else number, color = if (active || completed) Color.White else CalendarMuted, fontWeight = FontWeight.Bold)
        }
        Text(label, color = if (active) CalendarNavy else CalendarMuted, fontSize = 14.sp, fontWeight = if (active) FontWeight.Bold else FontWeight.Medium)
    }
}

@Composable
private fun CalendarImportUploadCard(
    state: CalendarUiState,
    onUpload: () -> Unit,
    onEvent: (CalendarUiEvent) -> Unit
) {
    Row(
        Modifier.fillMaxWidth().border(1.dp, CalendarBorder, RoundedCornerShape(10.dp)).padding(16.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        Icon(painterResource(Res.drawable.excel_file), "Calendar workbook", tint = AppSuccess, modifier = Modifier.size(46.dp))
        Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
            Text(state.importFileName.ifBlank { "No workbook selected" }, color = CalendarNavy, fontSize = 14.sp, fontWeight = FontWeight.Bold)
            Text(if (state.importFileBytes == null) "Select an .xlsx workbook to validate" else "${state.importFileBytes.size / 1024} KB  ·  Microsoft Excel Worksheet", color = CalendarMuted, fontSize = 12.sp)
            Text("The server validates rows and returns the review data.", color = CalendarMuted, fontSize = 12.sp)
        }
        AppOutlinedButton(
            onClick = { onEvent(CalendarUiEvent.ImportCurrentDataRequested) },
            modifier = Modifier.height(44.dp),
            contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 10.dp),
            colors = androidx.compose.material3.ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary)
        ) {
            Icon(painterResource(Res.drawable.download), "Download current calendar data", tint = AppPrimary, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(8.dp))
            Text("Download Current Data", color = AppPrimary, fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
        }
        AppOutlinedButton(
            onClick = { onEvent(CalendarUiEvent.ImportTemplateRequested) },
            modifier = Modifier.height(44.dp),
            contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 10.dp),
            colors = androidx.compose.material3.ButtonDefaults.outlinedButtonColors(contentColor = AppPrimary)
        ) {
            Icon(painterResource(Res.drawable.download), "Download template", tint = AppPrimary, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(8.dp))
            Text("Download Import Template", color = AppPrimary, fontSize = 13.sp, fontWeight = FontWeight.SemiBold)
        }
        AdminListPrimaryActionButton("Select and Validate", painterResource(Res.drawable.cloud_upload), onUpload, backgroundColor = AppPrimary)
    }
    if (state.importError.isNotBlank()) AppDialogErrorMessage(state.importError)
}

@Composable
private fun CalendarImportSummary(total: Int, valid: Int, invalid: Int) {
    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(14.dp)) {
        AdminListSummaryCard("Total Rows", total.toString(), "Workbook rows", painterResource(Res.drawable.excel_file), AppPrimary, com.schoolconnect.app.designsystem.AppPrimarySoft, CalendarMuted, Modifier.weight(1f), cardHeight = 116.dp, contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 14.dp, vertical = 12.dp), iconSize = 46.dp, iconGlyphSize = 24.dp, contentSpacing = 12.dp, valueFontSize = 22.sp)
        AdminListSummaryCard("Valid Rows", valid.toString(), "Ready to import", painterResource(Res.drawable.circle_check), AppSuccess, AppSuccessSoft, CalendarMuted, Modifier.weight(1f), cardHeight = 116.dp, contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 14.dp, vertical = 12.dp), iconSize = 46.dp, iconGlyphSize = 24.dp, contentSpacing = 12.dp, valueFontSize = 22.sp)
        AdminListSummaryCard("Invalid Rows", invalid.toString(), "Excluded", painterResource(Res.drawable.info_circle), AppDanger, AppDangerSoft, CalendarMuted, Modifier.weight(1f), cardHeight = 116.dp, contentPadding = androidx.compose.foundation.layout.PaddingValues(horizontal = 14.dp, vertical = 12.dp), iconSize = 46.dp, iconGlyphSize = 24.dp, contentSpacing = 12.dp, valueFontSize = 22.sp)
    }
}

@Composable
private fun CalendarImportInfo(message: String) {
    Row(
        Modifier.fillMaxWidth().background(AppInfoBg, RoundedCornerShape(8.dp)).border(1.dp, AppPrimary.copy(alpha = 0.25f), RoundedCornerShape(8.dp)).padding(horizontal = 14.dp, vertical = 10.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(10.dp)
    ) {
        Icon(painterResource(Res.drawable.info_circle), "Import information", tint = AppInfoText, modifier = Modifier.size(19.dp))
        Text(message, color = CalendarNavy, fontSize = 13.sp, fontWeight = FontWeight.Medium)
    }
}

@Composable
private fun CalendarImportInvalidTable(errors: List<CalendarImportErrorUi>) {
    Column(Modifier.fillMaxWidth().border(1.dp, CalendarBorder, RoundedCornerShape(8.dp))) {
        CalendarImportTableHeader(listOf("Row No.", "Event Date", "Event / Activity", "Status", "Error Message"), listOf(.65f, 1f, 1.5f, .8f, 1.8f))
        errors.forEach { row ->
            CalendarImportTableRow(listOf(row.rowNumber, row.date, row.title, "Invalid", row.message), listOf(.65f, 1f, 1.5f, .8f, 1.8f), invalid = true)
        }
    }
}

@Composable
private fun CalendarImportPreviewTable(rows: List<CalendarImportPreviewRow>) {
    Column(Modifier.fillMaxWidth().border(1.dp, CalendarBorder, RoundedCornerShape(8.dp))) {
        CalendarImportTableHeader(listOf("Date", "From", "To", "Event / Activity", "Event Type"), listOf(1f, .85f, .85f, 1.6f, 1.2f))
        rows.forEach { row -> CalendarImportTableRow(listOf(row.date, row.from, row.to, row.title, row.type), listOf(1f, .85f, .85f, 1.6f, 1.2f)) }
    }
}

@Composable
private fun CalendarImportTableHeader(labels: List<String>, weights: List<Float>) {
    Row(Modifier.fillMaxWidth().background(AppSecondaryBackground).padding(horizontal = 12.dp, vertical = 11.dp)) {
        labels.forEachIndexed { index, label -> Text(label, Modifier.weight(weights[index]), color = CalendarNavy, fontSize = 12.sp, fontWeight = FontWeight.Bold) }
    }
}

@Composable
private fun CalendarImportTableRow(values: List<String>, weights: List<Float>, invalid: Boolean = false) {
    Row(Modifier.fillMaxWidth().border(1.dp, CalendarBorder.copy(alpha = 0.55f)).padding(horizontal = 12.dp, vertical = 11.dp), verticalAlignment = Alignment.CenterVertically) {
        values.forEachIndexed { index, value ->
            Text(value, Modifier.weight(weights[index]), color = if (invalid && index == 3) AppDanger else CalendarNavy, fontSize = 12.sp, fontWeight = if (invalid && index == 3) FontWeight.Bold else FontWeight.Medium, maxLines = 1)
        }
    }
}

@Composable private fun RowScope.CalendarCell(text: String, columnWeight: Float) {
    AdminListTableBodyText(text, Modifier.weight(columnWeight).padding(end = 8.dp), color = CalendarNavy)
}

@Composable private fun ColumnScope.CalendarMonthView(
    state: CalendarUiState,
    onEvent: (CalendarUiEvent) -> Unit,
    readOnly: Boolean,
    onImport: () -> Unit
) {
    val month = calendarMonthInfo(state.month)
    val days = (month.previousMonthDays - month.leadingMondayIndex + 1..month.previousMonthDays).map { CalendarDayUi(it, muted = true) } +
        (1..month.daysInMonth).map { CalendarDayUi(it) } +
        (1..(42 - month.leadingMondayIndex - month.daysInMonth)).map { CalendarDayUi(it, muted = true) }
    Column(Modifier.fillMaxWidth().weight(1f), verticalArrangement = Arrangement.spacedBy(12.dp)) {
        Row(Modifier.fillMaxWidth().height(48.dp), verticalAlignment = Alignment.CenterVertically) {
            Box(Modifier.size(38.dp).border(1.dp, CalendarBorder, MaterialTheme.shapes.small).clickable { onEvent(CalendarUiEvent.MonthChanged(month.previous)) }, contentAlignment = Alignment.Center) {
                Icon(painterResource(Res.drawable.chevron_left), "Previous month", tint = AppPrimary, modifier = Modifier.size(20.dp))
            }
            Box(Modifier.weight(1f), contentAlignment = Alignment.Center) {
                Text(month.label, color = CalendarNavy, style = MaterialTheme.typography.headlineSmall, fontWeight = FontWeight.Bold)
            }
            Box(Modifier.size(38.dp).border(1.dp, CalendarBorder, MaterialTheme.shapes.small).clickable { onEvent(CalendarUiEvent.MonthChanged(month.next)) }, contentAlignment = Alignment.Center) {
                Icon(painterResource(Res.drawable.chevron_right), "Next month", tint = AppPrimary, modifier = Modifier.size(20.dp))
            }
        }
        // Keep enough vertical room for a two-line event title and its time.
        // On compact windows the weighted grid could otherwise clip the last line.
        Column(Modifier.fillMaxWidth().weight(1f).heightIn(min = 420.dp).border(1.dp, CalendarBorder, MaterialTheme.shapes.small).background(Color.White)) {
            Row(Modifier.fillMaxWidth().height(34.dp)) {
                listOf("MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN").forEach { day ->
                    Box(Modifier.weight(1f).fillMaxHeight().border(1.dp, CalendarBorder), contentAlignment = Alignment.Center) {
                        Text(day, color = CalendarNavy, style = MaterialTheme.typography.labelSmall, fontWeight = FontWeight.Bold)
                    }
                }
            }
            days.chunked(7).forEach { week ->
                Row(Modifier.fillMaxWidth().weight(1f)) {
                    week.forEach { day ->
                        val row = state.items.firstOrNull { item ->
                            !day.muted && item.date == calendarDateKey(day.number, month)
                        }
                        CalendarDayCell(day, row, onClick = { row?.let { onEvent(CalendarUiEvent.ViewRequested(it.id)) } })
                    }
                }
            }
        }
        Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
            CalendarLegend("All Day", CalendarBlueSoft, CalendarSelectedBorder)
            Spacer(Modifier.width(22.dp))
            CalendarLegend("Holiday", Color(0xFFE2E2E2), CalendarMuted)
            Spacer(Modifier.width(22.dp))
            CalendarLegend("Other Events", CalendarGreen, CalendarGreen)
            if (!readOnly) {
                Spacer(Modifier.weight(1f))
                AdminListToolbarButton("Import Calendar", painterResource(Res.drawable.download), onImport, width = 180.dp, borderColor = CalendarBorder, contentColor = CalendarNavy)
                Spacer(Modifier.width(14.dp))
                AdminListPrimaryActionButton("Add Events", painterResource(Res.drawable.plus), {}, backgroundColor = AppPrimary)
            }
        }
    }
}

private data class CalendarDayUi(val number: Int, val muted: Boolean = false)

private data class CalendarMonthInfo(
    val label: String,
    val shortName: String,
    val year: Int,
    val daysInMonth: Int,
    val leadingMondayIndex: Int,
    val previousMonthDays: Int,
    val previous: String,
    val next: String
)

private fun calendarMonthInfo(label: String): CalendarMonthInfo {
    val parts = label.trim().split(Regex("\\s+"))
    val monthNames = listOf("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December")
    val shortNames = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")
    val monthIndex = monthNames.indexOfFirst { it.equals(parts.getOrNull(0), ignoreCase = true) }
    val year = parts.getOrNull(1)?.toIntOrNull()
    if (monthIndex !in 0..11 || year == null) return CalendarMonthInfo("August 2026", "Aug", 2026, 31, 5, 31, "July 2026", "September 2026")
    fun daysIn(month: Int, targetYear: Int): Int = when (month) {
        1, 3, 5, 7, 8, 10, 12 -> 31
        4, 6, 9, 11 -> 30
        else -> if (targetYear % 400 == 0 || (targetYear % 4 == 0 && targetYear % 100 != 0)) 29 else 28
    }
    fun monthLabel(month: Int, targetYear: Int) = "${monthNames[month - 1]} $targetYear"
    val month = monthIndex + 1
    val previousMonth = if (month == 1) 12 else month - 1
    val previousYear = if (month == 1) year - 1 else year
    val nextMonth = if (month == 12) 1 else month + 1
    val nextYear = if (month == 12) year + 1 else year
    // Gregorian weekday calculation, normalized to Monday = 0.
    val adjustedMonth = if (month < 3) month + 12 else month
    val adjustedYear = if (month < 3) year - 1 else year
    val k = adjustedYear % 100
    val j = adjustedYear / 100
    val saturdayBased = (1 + (13 * (adjustedMonth + 1)) / 5 + k + k / 4 + j / 4 + 5 * j) % 7
    val leadingMondayIndex = (saturdayBased + 5) % 7
    return CalendarMonthInfo(
        label, shortNames[monthIndex], year, daysIn(month, year), leadingMondayIndex,
        daysIn(previousMonth, previousYear), monthLabel(previousMonth, previousYear), monthLabel(nextMonth, nextYear)
    )
}

private fun calendarDateKey(day: Int, month: CalendarMonthInfo): String =
    "${day.toString().padStart(2, '0')} ${month.shortName} ${month.year}"

@Composable private fun RowScope.CalendarDayCell(day: CalendarDayUi, row: CalendarRowUi?, onClick: () -> Unit) {
    Column(Modifier.weight(1f).fillMaxHeight().border(1.dp, CalendarBorder).clickable(enabled = row != null, onClick = onClick).padding(horizontal = 10.dp, vertical = 8.dp), verticalArrangement = Arrangement.spacedBy(7.dp)) {
        Text(day.number.toString(), color = if (day.muted) CalendarMuted else CalendarNavy, style = MaterialTheme.typography.bodyMedium)
        if (row != null) {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                val marker = when {
                    row.eventType.equals("Holiday", true) -> Color(0xFFE2E2E2)
                    row.isAllDay -> CalendarSelectedBorder
                    else -> CalendarGreen
                }
                Box(Modifier.width(4.dp).height(34.dp).background(marker, MaterialTheme.shapes.small))
                Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                    Text(
                        row.title,
                        color = if (row.eventType.equals("Holiday", true)) CalendarNavy else CalendarGreen,
                        style = MaterialTheme.typography.labelMedium,
                        fontSize = 11.sp,
                        maxLines = 1,
                        overflow = androidx.compose.ui.text.style.TextOverflow.Ellipsis
                    )
                    Text(if (row.isAllDay) "All Day" else row.from, color = CalendarMuted, style = MaterialTheme.typography.labelSmall, maxLines = 1)
                }
            }
        }
    }
}

@Composable private fun CalendarLegend(label: String, color: Color, borderColor: Color = color) {
    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(8.dp)) {
        Box(Modifier.size(10.dp).background(color, MaterialTheme.shapes.small).border(1.dp, borderColor, MaterialTheme.shapes.small))
        Text(label, color = CalendarMuted, style = MaterialTheme.typography.bodyMedium)
    }
}
